import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";

const initialListingsState = {
  HookList: [],
  HookMeta: {},
  currentPage: 1,
  pageSize: 10,
};

export const fetchHookApiLists = createAsyncThunk(
  "hookapiSlice/fetchHookApiLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getHookapiDetails, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "hookapi_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const createHookApi = createAsyncThunk(
  "hookapiSlice/createHookApi",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(API_ENDPOINTS.createHookApi, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "hookapi_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const deleteHookList = createAsyncThunk(
  "hookapiSlice/deleteHookList",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(API_ENDPOINTS.deleteHookApi, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "hookapi_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const hookapiSlice = createSlice({
  name: "hookapiSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
    builder.addCase(fetchHookApiLists.pending, (state) => {
      state.HookList = [];
    });
    builder.addCase(fetchHookApiLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      const { meta, objects } = data;
      state.HookList = objects;
      state.HookMeta = meta;
    });
    builder.addCase(createHookApi.pending, (state) => {
      state.HookList = [];
    });
    builder.addCase(createHookApi.fulfilled, (state, { payload }) => {
      const { data } = payload;
      const { meta, objects } = data;
      state.HookList = objects;
      state.HookMeta = meta;
    });
    builder.addCase(createHookApi.rejected, (state, action) => {});
  },

  reducers: {
    onPageAndPageSizeChange: (state, action) => {
      const { payload } = action;
      state.currentPage = payload["currentPage"];
      state.pageSize = payload["pageSize"];
    },
  },
});

export const { onPageAndPageSizeChange } = hookapiSlice.actions;
export default hookapiSlice.reducer;
